import { SessionManager, sessionManager } from './session-manager.js';
/**
 * Angular provider that will inject the default {@link SessionManager}
 * @public
 * @example
 * Simple example:
 * ```
 * import { Inject, NgModule } from '@angular/core';
 * import { sessionNgProvider, SessionManager } from '@onviobr/security-services';
 * @NgModule({
 * 	providers: [sessionNgProvider]
 * })
 * export class AppModule {
 * 	public constructor(@Inject(SessionManager) sessionManager: SessionManager) {
 * 		// now you have access to sessionManager
 * 	}
 * }
 * ```
 */
export const sessionNgProvider = {
    provide: SessionManager,
    useValue: sessionManager,
};
